import TableContainerReactTable from 'Components/Common/TableContainerReactTable';
import React, { useMemo } from 'react';
import { Row, Col } from 'reactstrap';

const ProductsTab: React.FC = () => {

  const columns = useMemo(() => [
    {
      header: 'Product Id',
      accessorKey: 'productId',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Size',
      accessorKey: 'size',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Colour',
      accessorKey: 'colour',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Product Code',
      accessorKey: 'productCode',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Name',
      accessorKey: 'productName',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Barcode',
      accessorKey: 'barcode',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
    {
      header: 'Vendor Prod Code',
      accessorKey: 'vendorProductCode',
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div>{cell.getValue()}</div>
      )
    },
  ], []);

  const data = useMemo(() => [
    { productId: '1001', size: '12', colour: 'Blue', productCode: 'P-1001', productName: 'Sample Product A', barcode: '1234567890123', vendorProductCode: 'V-1001' },
    { productId: '1002', size: '14', colour: 'Red', productCode: 'P-1002', productName: 'Sample Product B', barcode: '2234567890123', vendorProductCode: 'V-1002' },
    { productId: '1003', size: '16', colour: 'Yellow', productCode: 'P-1003', productName: 'Sample Product C', barcode: '3234567890123', vendorProductCode: 'V-1003' },
    { productId: '1004', size: '12', colour: 'Blue', productCode: 'P-1004', productName: 'Sample Product D', barcode: '4234567890123', vendorProductCode: 'V-1004' },
    { productId: '1005', size: '14', colour: 'Red', productCode: 'P-1005', productName: 'Sample Product E', barcode: '5234567890123', vendorProductCode: 'V-1005' },
    { productId: '1006', size: '16', colour: 'Yellow', productCode: 'P-1006', productName: 'Sample Product F', barcode: '6234567890123', vendorProductCode: 'V-1006' },
    { productId: '1007', size: '12', colour: 'Blue', productCode: 'P-1007', productName: 'Sample Product G', barcode: '7234567890123', vendorProductCode: 'V-1007' },
    { productId: '1008', size: '14', colour: 'Red', productCode: 'P-1008', productName: 'Sample Product H', barcode: '8234567890123', vendorProductCode: 'V-1008' },
    { productId: '1009', size: '16', colour: 'Yellow', productCode: 'P-1009', productName: 'Sample Product I', barcode: '9234567890123', vendorProductCode: 'V-1009' },
    { productId: '1010', size: '12', colour: 'Blue', productCode: 'P-1010', productName: 'Sample Product J', barcode: '1034567890123', vendorProductCode: 'V-1010' },
  ], []);

  return (
    <div className="products-tab">
      <fieldset className="border rounded m-1 p-2">
        <Row className="mt-1 mb-2">
          <div className='table-responsive'>
            <TableContainerReactTable
              columns={columns}
              data={data}
              isGlobalFilter={false}
              customPageSize={5}
              divClass="mb-0"
              tableClass="table-centered align-middle table-nowrap mb-0"
              theadClass="table-light"
              thClass="px-3 py-2"
              verticalLines={true}
            />
          </div>
        </Row>
        <Row>
          <Col>
            <button className="btn btn-soft-primary btn-sm">
              Rebuilt Product Names
            </button>
          </Col>
          <Col>
            <button className="btn btn-soft-primary btn-sm">
              Deactivate Products
            </button>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default ProductsTab;
